import type { QueryClient } from '@tanstack/react-query';
import type { LoaderFunctionArgs, RouteObject } from 'react-router';
import { trainingQuery } from '../api/training';
import type { RouteHandle } from '../app/RootLayout';
import { requireMe } from '../session/loaders';

const handle: RouteHandle = {
  help: { pageLabel: 'MyRewards training', topicIds: ['training', 'waiting', 'help-chat'] },
  search: {
    label: 'MyRewards training',
    meta: 'Five short lessons, a practice walkthrough and a three-question check',
  },
};

/** TRN1 (APP-076): everyone's training, reached from Waiting on you, Help and Search. */
export function trainingRoutes(queryClient: QueryClient): RouteObject[] {
  return [
    {
      path: 'training',
      loader: async ({ request }: LoaderFunctionArgs) => {
        await requireMe(queryClient, request);
        await queryClient.query(trainingQuery);
        return null;
      },
      lazy: async () => ({ Component: (await import('./TrainingPage')).TrainingPage }),
      handle,
    },
  ];
}
